import { render } from "./book-detail.vue?vue&type=template&id=d26998fe&scoped=true"
import script from "./book-detail.js?vue&type=script&lang=js&external"
export * from "./book-detail.js?vue&type=script&lang=js&external"

import "./book-detail.css?vue&type=style&index=0&id=d26998fe&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d26998fe"]])

export default __exports__